// extracted by mini-css-extract-plugin
export default {"Container":"Loader_Container__tjlZD","FullWidth":"Loader_FullWidth__jM-TD","Text":"Loader_Text__T+kNH"};